<template>
    <div class="nav-toggle" @click="toggleMenu">
        <span :class="{ active: isMenuOpen }"></span>
        <span :class="{ active: isMenuOpen }"></span>
        <span :class="{ active: isMenuOpen }"></span>
    </div>
    <div class="lang-switch" @click="toggleLanguage">
      <span class="lang-text">{{ currentLang === 'zh' ? 'EN' : '中' }}</span>
      <span class="lang-gap-icon">⇌</span>
    </div>
    <div class="s-logo" v-show="activeMenu != 0">
      <img v-if="currentLang == 'zh'" class="s-logo-img" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/mobile/logo.png" alt="">
      <img v-else class="s-logo-en" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/en_logo.png" alt="">
    </div>
    <transition name="fade">
        <div v-if="isMenuOpen" class="menu-overlay">
            <ul class="menu-list">
                <li
                v-for="(item, index) in menuList"
                :key="item.id"
                :class="[
                    activeMenu === item.id ? 'selected' : 'unselected',
                    index % 2 === 0 ? 'bg-dark' : 'bg-light'
                ]"
                @click="handleMenuClick(item)"
                >
                {{ currentLang === 'zh' ? item.name : item.en_name }}
                </li>
            </ul>

            <div class="social-box">
                <p @click="() => {router.push('/about_us'); isMenuOpen = false}">{{ currentLang === 'zh' ? '联系我们' : 'CONTACT US' }}</p>
                <div class="social-icons">
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/bilibili.png" alt="" @click="open_community_url('bilibili')"/>
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/douyin.png" alt="" @click="open_community_url('douyin')"/>
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/webo.png" alt="" @click="open_community_url('webo')"/>
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/xiaohongshu.png" alt="" @click="open_community_url('xiaohongshu')"/>
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/youtube.png" alt="" @click="open_community_url('youtube')" v-if="currentLang === 'en'"/>
                    <img class="community-icon" src="https://web.tos-cn-shanghai.volces.com/wangri/assets/x.png" alt="" @click="open_community_url('x')" v-if="currentLang === 'en'"/>
                </div>
            </div>
        </div>
     </transition>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import $bus from "../bus/index";
import { useRouter, useRoute } from 'vue-router'

const route = useRoute();
const router = useRouter();
const isMenuOpen = ref(false);
const activeMenu = ref(0);
const this_route = ref('home');
const currentLang = ref('zh');
watch(() => route.name,(newVal) => {
  this_route.value = newVal;
  
  console.log(this_route.value)
  if (newVal == 'news_detail') activeMenu.value = 4;
})
const menuList = [
  { name: '首页', en_name: 'HOME', id: 0 },
  { name: '世界观', en_name: 'LORE', id: 1 },
  { name: '游戏', en_name: 'GAME', id: 2 },
  { name: '壁纸', en_name: 'WALLPAPERS', id: 3 },
  { name: '资讯', en_name: 'NEWS', id: 4 }
]
$bus.on('change_nav_id', (data) => { // swiper-slide切换时，导航栏相应的高亮
  activeMenu.value = data.id;
});
onMounted(() => {
  const savedLang = localStorage.getItem('lang')
  if (savedLang === 'zh' || savedLang === 'en') {
    currentLang.value = savedLang
  }
})
function toggleLanguage() {
  currentLang.value = currentLang.value === 'zh' ? 'en' : 'zh'
  localStorage.setItem('lang', currentLang.value)
  if(route.name == 'news_detail' || route.name == 'mobile_news_detail') {
    window.location.reload();
    return;
  }
  window.location.href = window.location.origin + window.location.pathname;
}
const open_community_url = (value) => {
  switch (value) {
    case 'bilibili':
      window.open('https://space.bilibili.com/3546813030205509?spm_id_from=888.14.0.0', '_blank')
      break
    case 'douyin':
      window.open('https://v.douyin.com/Haq3kMv8mwA/ 7@2.com', '_blank')
      break
    case 'webo':
      window.open('https://weibo.com/u/8462703455', '_blank')
      break
    case 'xiaohongshu':
      window.open('https://xhslink.cn/o/2hn051kYb4T', '_blank')
      break
    case 'youtube':
      window.open('https://www.youtube.com/channel/UCCk9YgqZ4IEL42yoxxg2zXA', '_blank')
      break
    case 'x':
      window.open('https://x.com/The_wonder_ww', '_blank')
      break
    default:
      break
  }
}
const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

const handleMenuClick = (item) => {
  // activeMenu.value = item.id

  // $bus.emit('change_choice_id', { id: item.id });
  if (this_route.value != 'mobile') {
      router.push({path: '/mobile', query: {nav_active: item.id}})
      activeMenu.value = item.id;
      isMenuOpen.value = false
      return;
  }
  activeMenu.value = item.id;
  $bus.emit('change_choice_id', { id: item.id });
  isMenuOpen.value = false
}
</script>

<style scoped>
.page {
  position: relative;
  min-height: 100vh;
  background: #111;
}
.s-logo{
  position: fixed;
  left: 20px;
  top: 20px;
  z-index: 10;
  img{
    width: 67px;
    height: 48px;
  }
  .s-logo-en{
    width: 122px;
    height: 28px;
  }
}
.nav-toggle {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 24px;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transform: scale(0.8);
}

.nav-toggle span {
  display: block;
  width: 100%;
  height: 2px;
  background: #fff;
  transition: all 0.3s ease;
  transform-origin: center;
}



.lang-switch {
  position: fixed;
  top: 60px;
  right: 20px;
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.65);
  background: rgba(18, 18, 28, 0.9);
  color: rgba(255,255,255,0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: none;
  outline: none;
  transition: all 0.3s ease;
  transform: translateY(-4px);
  z-index: 10;
}

.lang-text {
  font-size: 14px;
  font-weight: 300;
  line-height: 1;
}

.lang-gap-icon {
  position: absolute;
  right: -2px;
  bottom: -7px;
  width: 14px;
  height: 14px;
  background: rgba(18, 18, 28, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgba(255,255,255,0.55);
  z-index: 2;
}

.lang-gap-icon::before {
  content: '';
  position: absolute;
  inset: -1px;
  background: rgba(18, 18, 28, 0.9);
  z-index: -1;
}

.lang-switch:hover {
  color: #fff;
  border-color: #fff;
}

.lang-switch:hover .lang-gap-icon {
  color: #fff;
}

.nav-toggle span:nth-child(1).active {
  transform: translateY(11px) rotate(45deg);
}
.nav-toggle span:nth-child(2).active {
  opacity: 0;
}
.nav-toggle span:nth-child(3).active {
  transform: translateY(-11px) rotate(-45deg);
}

/* 遮罩层 */
.menu-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  flex-direction: column;
  padding: 90px 24px 40px;
  box-sizing: border-box;
}

/* 菜单 */
.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-list li {
  height: 43px;
  line-height: 43px;
  padding: 0 20px;
  text-align: right;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

/* 文字状态 */
.menu-list li.unselected {
  color: rgba(255, 255, 255, 0.45);
}

.menu-list li.selected {
  color: #fff;
}

/* 背景交替灰度 */
.menu-list li.bg-dark {
  background: rgba(255, 255, 255, 0.08);
}

.menu-list li.bg-light {
  background: rgba(255, 255, 255, 0.04);
}

/* 底部 */
.social-box {
  margin-top: 30px;
  text-align: center;
  color: rgba(255, 255, 255, 0.45);
}

.social-box p {
  margin-bottom: 16px;
  font-size: 13px;
  font-weight: 600;
  &:active {
    color: #ffffff;
  }
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 16px;
  font-size: 24px;
}
.community-icon {
  width: 28px;
  height: 28px;
  padding: 0 5px;
  opacity: 0.6;
  &:active {
    opacity: 1;
  }
}
/* 动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>